export default {
    setWealthplanNotes({ commit }, payload) {
        commit('setWealthplanNotes', payload);
    },
    resetWealthplanNotes({ commit }) {
        commit('resetWealthplanNotes');
    },
};
